export class Soglia {
    public minConsumo: number;
    public maxConsumo: number;
    public consumoAnnuo: number;
    public consumoAnnuoBefore: number;
    public sogliacambio: number;
    public TipoResidente: number;
    public Potenza:number;
}


export class Soglie {

    public static SogliaMomoEleOld(): Array<Soglia>{
        return [
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 2700,
                consumoAnnuoBefore: 2700,
                sogliacambio: 0,
                TipoResidente:1,
                Potenza:3
            },
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 2700,
                consumoAnnuoBefore: 2700,
                sogliacambio: 0,
                TipoResidente:2,
                Potenza:3
            },
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 2700,
                consumoAnnuoBefore: 2700,
                sogliacambio: 0,
                TipoResidente:1,
                Potenza:4.5
            },
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 2700,
                consumoAnnuoBefore: 2700,
                sogliacambio: 0,
                TipoResidente:2,
                Potenza:4.5
            }
        ];
    }
    public static SogliaMomoEleNew(): Array<Soglia>{
        return [
           
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 2700,
                consumoAnnuoBefore: 2700,
                sogliacambio: 0,
                TipoResidente:1,
                Potenza:3
    
            } ,
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 4000,
                consumoAnnuoBefore: 4000,
                sogliacambio: 0,
                TipoResidente:2,
                Potenza:3
    
            },
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 3500,
                consumoAnnuoBefore: 3500,
                sogliacambio: 0,
                TipoResidente:1,
                Potenza:4.5
    
            },
            {
                minConsumo: 0,
                maxConsumo: 3000000,
                consumoAnnuo: 3500,
                consumoAnnuoBefore: 3500,
                sogliacambio: 0,
                TipoResidente:2,
                Potenza:4.5
    
            }
        ];
    }
    public static SoglieEle4Fasce(): Array<Soglia> {

        return [{
            minConsumo: 0,
            maxConsumo: 1950,
            consumoAnnuo: 1200,
            consumoAnnuoBefore: 1200,
            sogliacambio: 0,
            TipoResidente:1,
            Potenza:3

        },
        {
            minConsumo: 1950,
            maxConsumo: 3000,
            consumoAnnuo: 2700,
            consumoAnnuoBefore: 1200,
            sogliacambio: 1949,
            TipoResidente:1,
            Potenza:3
        },
        {
            minConsumo: 3000,
            maxConsumo: 4000,
            consumoAnnuo: 3500,
            consumoAnnuoBefore: 2700,
            sogliacambio: 2999,
            TipoResidente:1,
            Potenza:3
        },
        {
            minConsumo: 4000,
            maxConsumo: 20000000,
            consumoAnnuo: 4500,
            consumoAnnuoBefore: 3500,
            sogliacambio: 3999,
            TipoResidente:1,
            Potenza:3
        },
        {
            minConsumo: 0,
            maxConsumo: 1950,
            consumoAnnuo: 1200,
            consumoAnnuoBefore: 1200,
            sogliacambio: 0,
            TipoResidente:1,
            Potenza:4.5

        },
        {
            minConsumo: 1950,
            maxConsumo: 3000,
            consumoAnnuo: 2700,
            consumoAnnuoBefore: 1200,
            sogliacambio: 1949,
            TipoResidente:1,
            Potenza:4.5
        },
        {
            minConsumo: 3000,
            maxConsumo: 4000,
            consumoAnnuo: 3500,
            consumoAnnuoBefore: 2700,
            sogliacambio: 2999,
            TipoResidente:1,
            Potenza:4.5
        },
        {
            minConsumo: 4000,
            maxConsumo: 20000000,
            consumoAnnuo: 4500,
            consumoAnnuoBefore: 3500,
            sogliacambio: 3999,
            TipoResidente:1,
            Potenza:4.5
        },
        {
            minConsumo: 0,
            maxConsumo: 1950,
            consumoAnnuo: 1200,
            consumoAnnuoBefore: 1200,
            sogliacambio: 0,
            TipoResidente:2,
            Potenza:3

        },
        {
            minConsumo: 1950,
            maxConsumo: 3000,
            consumoAnnuo: 2700,
            consumoAnnuoBefore: 1200,
            sogliacambio: 1949,
            TipoResidente:2,
            Potenza:3
        },
        {
            minConsumo: 3000,
            maxConsumo: 4000,
            consumoAnnuo: 3500,
            consumoAnnuoBefore: 2700,
            sogliacambio: 2999,
            TipoResidente:2,
            Potenza:3
        },
        {
            minConsumo: 4000,
            maxConsumo: 20000000,
            consumoAnnuo: 4500,
            consumoAnnuoBefore: 3500,
            sogliacambio: 3999,
            TipoResidente:2,
            Potenza:3
        }
        ,
        {
            minConsumo: 0,
            maxConsumo: 1950,
            consumoAnnuo: 1200,
            consumoAnnuoBefore: 1200,
            sogliacambio: 0,
            TipoResidente:2,
            Potenza:4.5

        },
        {
            minConsumo: 1950,
            maxConsumo: 3000,
            consumoAnnuo: 2700,
            consumoAnnuoBefore: 1200,
            sogliacambio: 1949,
            TipoResidente:2,
            Potenza:4.5
        },
        {
            minConsumo: 3000,
            maxConsumo: 4000,
            consumoAnnuo: 3500,
            consumoAnnuoBefore: 2700,
            sogliacambio: 2999,
            TipoResidente:2,
            Potenza:4.5
        },
        {
            minConsumo: 4000,
            maxConsumo: 20000000,
            consumoAnnuo: 4500,
            consumoAnnuoBefore: 3500,
            sogliacambio: 3999,
            TipoResidente:2,
            Potenza:4.5
        }
        ];

    }

    public static SoglieIrenTuttoaposto()
    {
        return [
        {
            minConsumo: 0,
            maxConsumo: 1850,
            consumoAnnuo: 1500,
            consumoAnnuoBefore: 1500,
            sogliacambio: 0,
            TipoResidente:1,
            Potenza:3

        },
        {
            minConsumo: 1850,
            maxConsumo: 2450,
            consumoAnnuo: 2200,
            consumoAnnuoBefore: 1500,
            sogliacambio: 1849,
            TipoResidente:1,
            Potenza:3

        },
        {
            minConsumo: 2450,
            maxConsumo: 2950,
            consumoAnnuo: 2700,
            consumoAnnuoBefore: 2200,
            sogliacambio: 2449,
            TipoResidente:1,
            Potenza:3

        },
        {
            minConsumo: 2950,
            maxConsumo: 3000000,
            consumoAnnuo: 3200,
            consumoAnnuoBefore: 2700,
            sogliacambio: 2949,
            TipoResidente:1,
            Potenza:3

        },
        {
            minConsumo: 0,
            maxConsumo: 2450,
            consumoAnnuo: 900,
            consumoAnnuoBefore: 900,
            sogliacambio: 0,
            TipoResidente:2,
            Potenza:3

        },
        {
            minConsumo: 2450,
            maxConsumo: 3000000,
            consumoAnnuo: 4000,
            consumoAnnuoBefore: 900,
            sogliacambio: 0,
            TipoResidente:2,
            Potenza:3

        },
        {
            minConsumo: 0,
            maxConsumo: 3000000,
            consumoAnnuo: 3500,
            consumoAnnuoBefore: 3500,
            sogliacambio: 0,
            TipoResidente:1,
            Potenza:4.5

        },
        {
            minConsumo: 0,
            maxConsumo: 3000000,
            consumoAnnuo: 3500,
            consumoAnnuoBefore: 3500,
            sogliacambio: 0,
            TipoResidente:2,
            Potenza:4.5

        }

        ]
    }
    public static SoglieGas6Fasce(): Array<Soglia> {

        return [{
            minConsumo: 0,
            maxConsumo: 300,
            consumoAnnuo: 120,
            consumoAnnuoBefore: 120,
            sogliacambio: 0,
            TipoResidente:0,
            Potenza:0
        },
        {
            minConsumo: 300,
            maxConsumo: 590,
            consumoAnnuo: 480,
            consumoAnnuoBefore: 120,
            sogliacambio: 299,
            TipoResidente:0,
            Potenza:0
        },
        {
            minConsumo: 590,
            maxConsumo: 1000,
            consumoAnnuo: 700,
            consumoAnnuoBefore: 480,
            sogliacambio: 589,
            TipoResidente:0,
            Potenza:0
        },
        {
            minConsumo: 1000,
            maxConsumo: 1700,
            consumoAnnuo: 1400,
            consumoAnnuoBefore: 700,
            sogliacambio: 999,
            TipoResidente:0,
            Potenza:0
        },
        {
            minConsumo: 1700,
            maxConsumo: 3500,
            consumoAnnuo: 2000,
            consumoAnnuoBefore: 1400,
            sogliacambio: 1699,
            TipoResidente:0,
            Potenza:0
        },
        {
            minConsumo: 3500,
            maxConsumo: 2000000,
            consumoAnnuo: 5000,
            consumoAnnuoBefore: 2000,
            sogliacambio: 3499,
            TipoResidente:0,
            Potenza:0
        }

        ];

    }

}


// WEBPACK FOOTER //
// ./src/app/model/soglie.ts